import { render, staticRenderFns } from "./HealthEducationSharing.vue?vue&type=template&id=5e26d96e&scoped=true"
import script from "./HealthEducationSharing.vue?vue&type=script&lang=js"
export * from "./HealthEducationSharing.vue?vue&type=script&lang=js"
import style0 from "./HealthEducationSharing.vue?vue&type=style&index=0&id=5e26d96e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e26d96e",
  null
  
)

export default component.exports